import { render, staticRenderFns } from "./tiposAnuncios.vue?vue&type=template&id=1edcb733&scoped=true"
import script from "./tiposAnuncios.vue?vue&type=script&lang=js"
export * from "./tiposAnuncios.vue?vue&type=script&lang=js"
import style0 from "./tiposAnuncios.vue?vue&type=style&index=0&id=1edcb733&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edcb733",
  null
  
)

export default component.exports